module.exports = __webpack_public_path__ + "images/emoji/person_with_pouting_face.7abee0f4f1bc12b4471b.png";